export default function reducerCustomers(state = {}, action) {
  switch (action.type) {
    case 'GET_ORDERS':
      return {
        ...state,
        orders: action.payload.data,
      }
    default:
      return state
  }
}
